import React from 'react';

import FileUploadIcon from '@mui/icons-material/FileUpload';
import { DropzoneMessage } from 'component/Dropzone/Dropzone.s';

export namespace DropzoneEmptyMessage {
  export type Props = {
    icon?: React.ReactNode;
    children?: React.ReactNode;
  };
}

const DEFAULT_ICON = <FileUploadIcon style={{ width: 36, height: 36 }} color="inherit" />;
const DEFAULT_CHILDREN = 'Drop some files here, or click to select files to upload.';

export const DropzoneEmptyMessage: React.FC<DropzoneEmptyMessage.Props> = (props = {}) => {
  const { icon = DEFAULT_ICON, children = DEFAULT_CHILDREN } = props;
  return (
    <DropzoneMessage>
      {icon}
      <br />
      {children}
    </DropzoneMessage>
  );
};
